export default {"src":"/_next/static/media/sports8.33c3a560.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};